export const SET_CAMPAIGNS = 'setCampaigns'
export const ADD_CAMPAIGNS = 'addCampaigns'
export const SET_LOADED = 'setLoaded'
export const SET_CAMPAIGNS_PAGE = 'setCampaignsPage'
export const RESET_STATE = 'resetState'
export const SET_SEARCH_NAME = 'setSearchName'
